import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { ProductsList } from './ProductsList';
import { SpecFilterGroup, useCategoryProducts } from './useFilteredProducts';
import { RoleType } from '@/services/authentication/hooks/user';

export const CategoryProducts = ({
  categoryId,
  searchQuery,
  specFilter,
  manufacturerFilter
}: {
  categoryId: string;
  searchQuery?: string;
  specFilter?: SpecFilterGroup[];
  manufacturerFilter?: string[];
}) => {
  const role = useCatalogueService(s => s.configuration.for);
  const isAdmin = role === RoleType.Admin;

  const products = useCategoryProducts(categoryId, { searchQuery, specFilter, manufacturerFilter, applyRegionFilter: isAdmin });

  return (
    <div className="px-6">
      {products.length > 0 ? (
        <ProductsList products={products} />
      ) : (
        <div className="font-semibold">
          {searchQuery || specFilter ? 'No products match the current search filter.' : 'This category has no products'}
        </div>
      )}
    </div>
  );
};
